import { Title as AntdTitle } from "@empglabs/backoffice-ui-kit"

const Title = props => {
  return <AntdTitle {...props} />
}

export default Title
